import { createStore } from "vuex";

export default createStore({
  state: {
    hideConfigButton: false,
    isPinned: true,
    showConfig: false,
    sidebarType: "bg-white",
    isRTL: false,
    mcolor: "",
    darkMode: false,
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    layout: "default",
  },
  mutations: {
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    sidebarMinimize(state) {
      let sidenav_show = document.querySelector("#app");
      if (state.isPinned) {
        sidenav_show.classList.add("g-sidenav-hidden");
        sidenav_show.classList.remove("g-sidenav-pinned");
        state.isPinned = false;
      } else {
        sidenav_show.classList.add("g-sidenav-pinned");
        sidenav_show.classList.remove("g-sidenav-hidden");
        state.isPinned = true;
      }
    },
    // El estado inicial de "isPinned" (true) asume el arranque en escritorio,
    // donde el primer clic del toggle debe colapsar a modo mini (agregar
    // g-sidenav-hidden). Pero por debajo de xl, el sidenav arranca oculto
    // fuera de pantalla (ver media-breakpoint-down(xl) en
    // _navbar-vertical.scss) SIN que se le haya agregado ninguna clase
    // todavía -- si no se corrige acá, el primer toque del hamburger en
    // móvil no hace nada visible (agrega g-sidenav-hidden, que ya estaba
    // "hidden" de por sí) y recién el segundo toque abre el menú. Se llama
    // una sola vez al montar la app (App.vue), según el ancho real de
    // pantalla en ese momento.
    setInitialPinned(state, isMobile) {
      state.isPinned = !isMobile;
    },
    sidebarType(state, payload) {
      state.sidebarType = payload;
    },
    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true;
      } else {
        state.isNavFixed = false;
      }
    },
  },
  actions: {
    toggleSidebarColor({ commit }, payload) {
      commit("sidebarType", payload);
    },
  },
  getters: {},
});
